"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuDots = void 0;
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.MenuDots = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, { width: "24", height: "6", viewBox: "0 0 24 6", fill: "none" },
    React.createElement("circle", { cx: "3", cy: "3", r: "3", fill: props.fill || common_styles_1.black }),
    React.createElement("circle", { cx: "12", cy: "3", r: "3", fill: props.fill || common_styles_1.black }),
    React.createElement("circle", { cx: "21", cy: "3", r: "3", fill: props.fill || common_styles_1.black }))); };
//# sourceMappingURL=menudots.js.map